import PropTypes from 'prop-types';
import UIMedia from 'UIComponents/layout/UIMedia';
import { MEDIA_ALIGNMENT_TYPES } from 'UIComponents/layout/MediaConstants';
import UITileSection from 'UIComponents/tile/UITileSection';
import { jsx as _jsx } from "react/jsx-runtime";
const TileMessageBody = ({
  className,
  align = 'start',
  children
}) => /*#__PURE__*/_jsx(UITileSection, {
  className: className,
  children: /*#__PURE__*/_jsx(UIMedia, {
    align: align,
    children: children
  })
});
TileMessageBody.displayName = 'TileMessageBody';
TileMessageBody.propTypes = {
  align: PropTypes.oneOf(Object.keys(MEDIA_ALIGNMENT_TYPES)),
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
TileMessageBody.defaultProps = {
  align: 'start'
};
export default TileMessageBody;